// (function () {
//   function addClassToNextDiv() {
//     document.querySelectorAll('.active-filter-wrapper').forEach(el => {
//       const nextDiv = el.nextElementSibling;
//       if (nextDiv && nextDiv.tagName === 'DIV') {
//         nextDiv.classList.add('has-active-filter');
//       }
//     });
//   }

//   addClassToNextDiv();

//   new MutationObserver(addClassToNextDiv)
//     .observe(document.body, { childList: true, subtree: true });
// })();

(function () {

  function addClassesToNextElement(config) {
    const { triggerSelector, classesToAdd } = config;

    document.querySelectorAll(triggerSelector).forEach(el => {
      const nextEl = el.nextElementSibling;
      if (nextEl) {
        nextEl.classList.add(...classesToAdd);
      }
    });
  }

  function init() {
    addClassesToNextElement({
      triggerSelector: '.active-filter-wrapper',
      classesToAdd: ['has-active-filter']
    });
// future add class
       addClassesToNextElement({
      triggerSelector: '.parent-diamond-proxy-product-details',
      classesToAdd: ['custome-product-details']
    });
        addClassesToNextElement({
      triggerSelector: '.color-block-header',
      classesToAdd: ['custome-color-list']
    });
            addClassesToNextElement({
      triggerSelector: '.custome-color-list',
      classesToAdd: ['color-header']
    });
      addClassesToNextElement({
      triggerSelector: '.view-details-wrapper',
      classesToAdd: ['image-view-wrapper']
    });
       addClassesToNextElement({
      triggerSelector: '.parent-custome-color-list',
      classesToAdd: ['daimond-color-list']
    });
       addClassesToNextElement({
      triggerSelector: '.unique-color-list',
      classesToAdd: ['unique-color-view']
    });
    addClassesToNextElement({
      triggerSelector: '.expand-filter-section',
      classesToAdd: ['show-more-filter']
    });
    
       addClassesToNextElement({
      triggerSelector: '.expand-filter-section',
      classesToAdd: ['show-more-filter']
    });
       addClassesToNextElement({
      triggerSelector: '.diamond-proxy-filter-parent-container',
      classesToAdd: ['advanced-filter']
    });
  }
 
  init();

  new MutationObserver(init).observe(document.body, {
    childList: true,
    subtree: true
  });

})();


(function () {
  const CHILD_SELECTOR = '.diamond-proxy-add-to-cart';
  const PARENT_STATIC_CLASS = 'add-to-cart-parent';
  
  function addStaticClassToParent() {
    document.querySelectorAll(CHILD_SELECTOR).forEach(child => {
      // 🔑 child ke parent se closest button dhundo
      const parentBtn = child.parentElement?.closest('button');

      if (parentBtn && parentBtn !== child) {
        parentBtn.classList.add(PARENT_STATIC_CLASS);
      }
    });
  }

  // run once
  addStaticClassToParent();

  // Shopify / dynamic content safe
  new MutationObserver(addStaticClassToParent).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {
  const CHILD_SELECTOR = '.left';
  const PARENT_CLASS = 'has-left-child';

  function addClass() {
    document.querySelectorAll(CHILD_SELECTOR).forEach(child => {
      const parent = child.parentElement;
      if (parent) {
        parent.classList.add(PARENT_CLASS);
      }
    });
  }

  addClass();

  new MutationObserver(addClass).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  const CHILD_SELECTOR1 = '.daimond-color-list';
  const CLASS_TO_ADD = 'daimond-color-list';

  function addClassToPreviousDiv() {
    document.querySelectorAll(CHILD_SELECTOR1).forEach(child => {
      const prevDiv = child.previousElementSibling;

      if (prevDiv && prevDiv.tagName === 'DIV') {
        prevDiv.classList.add(CLASS_TO_ADD);
      }
    });
  }

  // run once
  addClassToPreviousDiv();

  // Shopify / dynamic safe
  new MutationObserver(addClassToPreviousDiv).observe(document.body, {
    childList: true,
    subtree: true
  });
})();





(function () {

  function addClassToFourthDivInsideParent(config) {
    const { parentSelector, classToAdd } = config;

    document.querySelectorAll(parentSelector).forEach(parent => {
      const children = parent.children;
      if (children.length >= 4) {          // ✅ correct check
        children[3].classList.add(classToAdd); // 4th div
      } 
    });
  }

  function initAddClass() {
    addClassToFourthDivInsideParent({
      parentSelector: '.diamond-proxy-filter-parent-container',
      classToAdd: 'diamond-proxy-overtone'
    });
  }

  // run once
  initAddClass();

  // dynamic / Shopify safe
  new MutationObserver(initAddClass).observe(document.body, {
    childList: true,
    subtree: true
  });

})();







// (function () {

//   function addClassesToAllChildren(config) {
//     const { parentSelector, classMap } = config;

//     document.querySelectorAll(parentSelector).forEach(parent => {
//       const children = parent.children;

//       Object.keys(classMap).forEach(index => {
//         if (children[index]) {
//           children[index].classList.add(classMap[index]);
//         }
//       });
//     });
//   }

//   function initAddClasses() {
//     addClassesToAllChildren({
//       parentSelector: '.diamond-proxy-filter-parent-container',
//       classMap: {
//         0: 'diamond-varity-block',
//         1: 'diamond-shape-block',
//         2: 'diamond-carat-block',
//         3: 'diamond-color-block'
//           4: 'diamond-clarity-block'
//             5: 'diamond-cut-block'
//               6: 'diamond-price-block'
//       }
//     });
//   }

//   // run once
//   initAddClasses();

//   // dynamic / Shopify safe
//   new MutationObserver(initAddClasses).observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// })();








(function () {

  function addDifferentClassesToChildren(config) {
    const { parentSelector, classMap } = config;

    document.querySelectorAll(parentSelector).forEach(parent => {
      const children = parent.children;

      Object.entries(classMap).forEach(([index, className]) => {
        if (children[index]) {
          children[index].classList.add(className);
        }
      });
    });
  }

  function init() {
    addDifferentClassesToChildren({
      parentSelector: '.diamond-proxy-filter-parent-container',
      classMap: {
        0: 'diamond-filter-varity',
        1: 'diamond-filter-shape',
        2: 'diamond-filter-carat',
        3: 'diamond-filter-color',
        4: 'diamond-filter-clarity',
        5: 'diamond-filter-cut',
        6: 'diamond-filter-price'

      }
    });
  }

  // run once
  init();

  // Shopify / dynamic DOM safe
  new MutationObserver(init).observe(document.body, {
    childList: true,
    subtree: true
  });

})();





(function () {

  function applyClassToSecondChild(config) {
    const { containerSelector, newClassName } = config;

    document.querySelectorAll(containerSelector).forEach(container => {
      const children = container.children;
      if (children.length >= 3) {
        children[2].classList.add(newClassName);
      }
    });
  }

function initializeSecondChildClass(){
    applyClassToSecondChild({
      containerSelector: '.diamond-proxy-overtone',
      newClassName: 'expand-filter-section'
    });
}

  // run once
  initializeSecondChildClass();

  // dynamic / Shopify safe
  new MutationObserver(initializeSecondChildClass).observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// (function () {

//   function applyClassToThirdDiv(config) {
//     const { containerSelector, newClassName } = config;

//     document.querySelectorAll(containerSelector).forEach(container => {
//       const divChildren = container.querySelectorAll(':scope > div');

//       if (divChildren.length >= 3) {
//         divChildren[2].classList.add(newClassName);
//       }
//     });
//   }

//   function initThirdDivClass() {
//     applyClassToThirdDiv({
//       containerSelector: '.diamond-proxy-overtone',
//       newClassName: 'expand-filter-section'
//     });
//   }

//   // run once
//   initThirdDivClass();

//   // Shopify dynamic safe
//   new MutationObserver(initThirdDivClass).observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// })();
